import { render, staticRenderFns } from "./ItemDiscounts.vue?vue&type=template&id=02d5f850&scoped=true&"
import script from "./ItemDiscounts.vue?vue&type=script&lang=js&"
export * from "./ItemDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ItemDiscounts.vue?vue&type=style&index=0&id=02d5f850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d5f850",
  null
  
)

export default component.exports